import script from "./SelectSwap.vue?vue&type=script&setup=true&lang=js"
export * from "./SelectSwap.vue?vue&type=script&setup=true&lang=js"

import "./SelectSwap.vue?vue&type=style&index=0&id=2d05c916&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2d05c916"]])

export default __exports__